export default __webpack_public_path__ + "static/media/waiting-room-studio-reverse.3ce01d91.mp4";